import {connect} from '@modifi/redux'
import {aPush} from '@modifi/router'
import {compose} from 'ramda'
import {withSuspense} from '@modifi/plugin-onboarding'
import {getAuthenticatedThemisClient} from '@modifi/onboarding-api-clients'
import {selectCountries} from '@modifi/plugin-countries'
import {aShowDialog} from '@modifi/plugin-dialogs'

import CompanyNameSearch from './CompanyNameSearch'
import {selectLegalFormsByCountryCode} from '../../../../data/legal-forms'
import {getRiskCountries} from '../../utils'
import {BUYER_SEARCH_DIALOG} from '../../dialogs'

const apiClient = getAuthenticatedThemisClient()

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const mapStateToProps = (state: Record<string, any>, ownProps: any) => {
  const externalTradePartnerId = ownProps?.match?.params?.externalId as string
  const countries = selectCountries(state)
  return {
    externalTradePartnerId,
    highBuyerRiskCountries: getRiskCountries(countries, 'HIGH'),
    getLegalForms: (countryCode: string): string[] =>
      selectLegalFormsByCountryCode(state, countryCode),
    onSearch: (searchString: string, countryCode: string, addressState?: string): any =>
      apiClient.PublicRegisteredCompanies.search({
        partialCompanyName: searchString,
        countryCode,
        ...(addressState ? {state: addressState} : {}),
      })
        .then(res => res.data()?.companies || [])
        .then(companies =>
          companies?.map(company => ({
            address: company?.company?.address,
            companyName: company?.company?.companyName,
            companyIds: company?.companyIds,
            legalForm: company?.company?.legalForm,
            website: company?.company?.website,
          }))
        ),
  }
}

const mapDispatchToProps = {
  redirect: aPush,
  openBuyerSearchDialog: (params: Record<string, any>): any =>
    aShowDialog(BUYER_SEARCH_DIALOG, params),
}

export default compose(
  withSuspense(false),
  connect(mapStateToProps, mapDispatchToProps)
)(CompanyNameSearch)
